export default {
    biToursBySiteAndDate: 'BI_TOURS_BY_SITE_AND_DATE',
    biToursByDate: 'BI_TOURS_BY_DATE',
    biToursBySite: 'BI_TOURS_BY_SITE',
    biToursScheduleStatistics: 'BI_TOURS_SCHEDULE_STATISTICS',
    biToursByEmployee: 'BI_TOURS_BY_EMPLOYEE',
    biTourLog: 'BI_TOUR_LOG',
    setLoadingState: 'BI_TOURS_SET_LOADING_STATE',
  };